import React, { useEffect, useState } from 'react';
import { useRoutes, useNavigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';


import _publicRoutes from './_public';
import _privateRoutes from './_private';
import { LOCAL_STORAGE_KEY } from 'src/constants';
import { useAppSelector } from 'src/stores';


const RootRouter: React.FC = () => {
  const navigate = useNavigate();

  const { meInfo, error } = useAppSelector((state) => state.auth);
  const [routes, setRoutes] = useState<RouteObject[]>([..._publicRoutes]);

  useEffect(() => {
    const token = localStorage.getItem(LOCAL_STORAGE_KEY.TOKEN) as string;
    if (token) {
      setRoutes([..._publicRoutes, ..._privateRoutes]);
    } else {
      setRoutes([..._publicRoutes]);
      navigate('/login');
    }
  }, [meInfo]);

  useEffect(() => {
    if (error) {
      localStorage.removeItem(LOCAL_STORAGE_KEY.TOKEN);
      navigate('/login');
    } else {
      setRoutes([..._publicRoutes, ..._privateRoutes]);
    }
  }, [error]);

  return <>{useRoutes(routes)}</>;
};

export default RootRouter;
